import { render, staticRenderFns } from "./management-config-parameter-view.vue?vue&type=template&id=e2c4856c&"
import script from "./management-config-parameter-view.vue?vue&type=script&lang=js&"
export * from "./management-config-parameter-view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports